import DotNetObject = DotNet.DotNetObject;
import { CrmContact } from '@crimsontide/core/client/interfaces';

export const CrmContactService = (() => {
  let dotNetObj: DotNetObject;
  let cachedCrmContacts: CrmContact[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getCrmContacts = async (useCache: boolean = true): Promise<CrmContact[]> => {
    if (useCache && cachedCrmContacts != null)
      return cachedCrmContacts;

    if (dotNetObj) {
      cachedCrmContacts = await dotNetObj.invokeMethodAsync<CrmContact[]>('GetAsync');
      return cachedCrmContacts;
    } else {
      throw 'Crm Contact DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getCrmContacts,
  };
})();
